<div class="flex flex-col h-full">
    <div class="flex-1 overflow-y-auto">
        <ul class="layout-menu">
            <ng-container *ngFor="let item of model; let i = index">
                <li app-menu-item *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
                <li *ngIf="item.separator" class="menu-separator"></li>
            </ng-container>
        </ul>
        <!-- @if(isLoggedIn()){ -->
        @if(isLoggedIn()){
        <ul class="layout-menu">
            <ng-container *ngFor="let item of adminModel; let i = index">
                <li app-menu-item [item]="item" [index]="i" [root]="true"></li>
            </ng-container>
        </ul>
        }

    </div>
    @if (!isLoggedIn()) {
    <div class="mt-auto">
        <ul class="layout-menu">
            <ng-container *ngFor="let item of reservedAreaModel; let i = index">
                <li app-menu-item [item]="item" [index]="i" [root]="true"></li>
            </ng-container>
        </ul>
    </div>
    }
</div>